<template>
  <div ref="hubspotChat"></div>
</template>

<script>
import { noChatInThisRoutes } from '@/util/helpers'

export default {
  name: 'HubspotChat',

  data() {
    return {
      noChatInThisRoutes,
    }
  },

  mounted() {
    const userCountry = localStorage.getItem('user_country')
    if (userCountry !== 'BR') return

    const chatWrapper = this.$refs.hubspotChat
    const hubspotChat = document.createElement('script')

    hubspotChat.setAttribute(
      'src',
      'https:////js.hs-scripts.com/7356861.js'
    )

    chatWrapper.appendChild(hubspotChat)
    setTimeout(() => this.checkShowHubspotChat(this.$route.name), 1000)
  },

  watch: {
    $route({ name }) {
      this.checkShowHubspotChat(name)
    },
  },

  methods: {
    checkShowHubspotChat(route) {
      const chatElement = document.querySelector('.widget-align-right')

      this.$nextTick(() => {
        if (!chatElement) return

        noChatInThisRoutes.includes(route)
          ? chatElement.classList.add('hideChat')
          : chatElement.classList.remove('hideChat')
      })
    },
  },
}
</script>
